import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftsStatuses';

import { DraftStatus } from '../../model/draft';
import { Channel } from '../../model/skill';

const t = i18n(keyset);

const DEFAULT_STRINGS: Record<DraftStatus, ''> = {
    [DraftStatus.InDevelopment]: '',
    [DraftStatus.ReviewRequested]: '',
    [DraftStatus.ReviewApproved]: '',
    [DraftStatus.DeployRequested]: '',
    [DraftStatus.ReviewCancelled]: '',
    [DraftStatus.ReviewRejected]: '',
    [DraftStatus.DeployRejected]: '',
    [DraftStatus.TestRequired]: '',
    [DraftStatus.MeetingApproval]: '',
    [DraftStatus.WaitingForTesting]: '',
    [DraftStatus.AppScanRequested]: '',
    [DraftStatus.AppScanRequestedAfterModeration]: '',
    [DraftStatus.DevicesTesting]: '',
    [DraftStatus.DevicesTestingCompleted]: '',
};

const commonStrings: Record<DraftStatus, string> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.InDevelopment]: t('draft-in-development'),
    [DraftStatus.ReviewRequested]: t('review-requested'),
    [DraftStatus.ReviewApproved]: t('review-approved'),
    [DraftStatus.DeployRequested]: t('deploy-requested'),
};

const smartHomeStrings: Record<DraftStatus, string> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.InDevelopment]: t('sh-in-dev'),
    [DraftStatus.ReviewRequested]: t('sh-review-requested'),
    [DraftStatus.MeetingApproval]: t('sh-meeting'),
    [DraftStatus.WaitingForTesting]: t('sh-waiting'),
    [DraftStatus.DevicesTesting]: t('sh-testing'),
    [DraftStatus.DevicesTestingCompleted]: t('sh-analysis'),
    [DraftStatus.ReviewApproved]: t('sh-approved'),
    [DraftStatus.DeployRequested]: t('deploy-requested'),
};

export const smartHomeStatuses: Record<DraftStatus, '' | keyof (typeof keyset)['en']> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.InDevelopment]: 'sh-in-dev',
    [DraftStatus.ReviewRequested]: 'sh-review-requested',
    [DraftStatus.MeetingApproval]: 'sh-meeting',
    [DraftStatus.WaitingForTesting]: 'sh-waiting',
    [DraftStatus.DevicesTesting]: 'sh-testing',
    [DraftStatus.DevicesTestingCompleted]: 'sh-analysis',
    [DraftStatus.ReviewApproved]: 'sh-approved',
    [DraftStatus.DeployRequested]: 'deploy-requested',
};

export const draftStatusLabels: Record<Channel, Record<DraftStatus, string>> = {
    [Channel.AliceSkill]: commonStrings,
    [Channel.AutoApp]: { ...commonStrings, [DraftStatus.InDevelopment]: t('in-development') },
    [Channel.Thereminvox]: commonStrings,
    [Channel.SmartHome]: smartHomeStrings,
    [Channel.TvApp]: { ...commonStrings, [DraftStatus.InDevelopment]: t('in-development') },
    [Channel.SmartScreenApp]: { ...commonStrings, [DraftStatus.InDevelopment]: t('in-development') },
};

export const draftStatusHint: Record<DraftStatus, string> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.InDevelopment]: t('hint-in-dev'),
};

const commonCompletedModerationStateTexts: Record<DraftStatus, string> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.ReviewRequested]: t('ready'),
    [DraftStatus.ReviewApproved]: t('ready'),
    [DraftStatus.DeployRequested]: t('ready'),
};

const smartHomeCompletedModerationStateTexts: Record<DraftStatus, string> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.ReviewRequested]: t('ready'),
    [DraftStatus.MeetingApproval]: t('ready'),
    [DraftStatus.WaitingForTesting]: t('ready'),
    [DraftStatus.DevicesTesting]: t('ready'),
    [DraftStatus.DevicesTestingCompleted]: t('ready'),
    [DraftStatus.ReviewApproved]: t('ready'),
    [DraftStatus.DeployRequested]: t('ready'),
};

export const smartHomeModerationLabels: Record<DraftStatus, '' | keyof (typeof keyset)['en']> = {
    ...DEFAULT_STRINGS,
    [DraftStatus.ReviewRequested]: 'ready',
    [DraftStatus.MeetingApproval]: 'ready',
    [DraftStatus.WaitingForTesting]: 'ready',
    [DraftStatus.DevicesTesting]: 'ready',
    [DraftStatus.DevicesTestingCompleted]: 'ready',
    [DraftStatus.ReviewApproved]: 'ready',
    [DraftStatus.DeployRequested]: 'ready',
};

export const completedModerationStateTexts: Record<Channel, Record<DraftStatus, string>> = {
    [Channel.AliceSkill]: commonCompletedModerationStateTexts,
    [Channel.Thereminvox]: commonCompletedModerationStateTexts,
    [Channel.SmartHome]: smartHomeCompletedModerationStateTexts,
    [Channel.TvApp]: commonCompletedModerationStateTexts,
    [Channel.SmartScreenApp]: commonCompletedModerationStateTexts,
    [Channel.AutoApp]: commonCompletedModerationStateTexts,
};
